<template>
  <div class="edit-update">
    <b-field label="Title">
      <b-input type="textarea" v-model="update.message" placeholder="Your Update" required></b-input>
    </b-field>
    <div class="columns">
      <div class="column">
        <b-field v-if="update.dateCreated" label="Date Created">
          <b-datepicker
            v-model="update.dateCreated"
            placeholder="Click to select..."
            icon="calendar"
            position="is-bottom-right"
          >
            <button class="button is-primary" @click="date = new Date()">
              <b-icon icon="calendar"></b-icon>
              <span>Today</span>
            </button>
          </b-datepicker>
        </b-field>
      </div>
      <div class="column">
        <b-field v-if="update.dateCreated" label="Time">
          <b-timepicker
            v-model="update.dateCreated"
            :inline="false"
            :enable-seconds="true"
            :mobile-native="true"
            icon="clock-o"
          ></b-timepicker>
        </b-field>
      </div>
    </div>

    <div class="controls">
      <button class="button is-primary" @click="saveUpdate">Save</button>
      <button v-if="updateId" class="button is-danger" @click="deleteUpdate">{{ deleteUpdateText }}</button>
    </div>
  </div>
</template>

<script>
import { firestore } from "@/firebase";
var db = firestore;

export default {
  name: "EditUpdate",
  props: ["updateId"],
  data() {
    return {
      deletingUpdate: false,
      editingUpdate: false,
      update: {
        message: null,
        dateCreated: null
      }
    };
  },
  mounted() {
    if (this.updateId) {
      let ref = `/Updates/${this.updateId}`;
      db.doc(ref)
        .get()
        .then(doc => {
          if (doc.exists) {
            console.log("Document exists and available for editing");
            this.editingUpdate = true;
            let updateDate = doc.data();
            this.update.message = updateDate.message;
            this.update.dateCreated = new Date(updateDate.dateCreated.seconds * 1000);
          } else {
            this.$toast.open({
              message: "No such document available",
              type: "is-danger",
              duration: 3000,
              position: "is-bottom"
            });
            this.$router.go(-1);
          }
        })
        .catch(error => {
          console.log("error getting document : " + error);
        });
    } else {
      console.log("creating a new updaate");
      this.update.dateCreated = new Date();
    }
  },
  methods: {
    deleteUpdate: function() {
      if (this.deletingUpdate) {
        let ref = `/Updates/`;
        db.collection(ref)
          .doc(this.updateId)
          .delete()
          .then(() => {
            console.log("update deleted");
            this.$toast.open({
              message: "The update has been deleted",
              type: "is-success",
              duration: 3000,
              position: "is-bottom"
            });
            this.$router.go(-1);
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.deletingUpdate = true;
      }
    },
    saveUpdate: function() {
      var dataToSave = {
        message: this.update.message,
        dateCreated: this.update.dateCreated
      };
      var saveSuccessFullHanlder = () => {
        console.log("Successfull added update");
        this.$toast.open({
          message: "The update has been recorded",
          type: "is-success",
          duration: 3000,
          position: "is-bottom"
        });
        this.$router.go(-1);
      };

      if (this.updateId) {
        let ref = `/Updates`;
        db.collection(ref)
          .doc(this.updateId)
          .update(dataToSave)
          .then(saveSuccessFullHanlder);
      } else {
        let ref = `/Updates`;
        console.log(ref);
        db.collection(ref)
          .add(dataToSave)
          .then(saveSuccessFullHanlder)
          .catch(error => {
            console.log("Error adding update : " + error);
          });
      }
    }
  },
    computed: {
    deleteUpdateText: function() {
      if (this.deletingEvent) {
        return "Confirm Delete";
      } else {
        return "Delete";
      }
    }
  }
};
</script>

<style>
.controls button {
  margin-left: 10px;
}
</style>